import React from 'react';

interface ResultsToolbarProps {
  pagination: any;
  sort: string;
  onSortChange: (sort: string) => void;
}

const ResultsToolbar: React.FC<ResultsToolbarProps> = ({ pagination, sort, onSortChange }) => {
  const sortOptions = [
    { value: 'created_at desc', label: '新着順' },
    { value: 'max_reward desc', label: '単価順' }
  ];

  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onSortChange(e.target.value);
  };

  if (!pagination || pagination.total_count === 0) {
    return null;
  }

  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div>
        <span className="text-muted">
          {pagination.from}〜{pagination.to}件目 / 全{pagination.total_count.toLocaleString()}件
        </span>
      </div>
      
      <div className="d-flex align-items-center">
        <label className="form-label me-2 mb-0 text-nowrap">並び順:</label>
        <select 
          value={sort} 
          onChange={handleSortChange}
          className="form-select form-select-sm"
          style={{ width: 'auto' }}
        >
          {sortOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ResultsToolbar;
